import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import plugins from './plugins'
import actions from './actions'
import moduleUser from './users/index'
import modulePage from './pages/index'
import moduleSearch from './search/index'
import moduleDashboard from './dashboard/index'
import modulePriceHistory from './priceHistory/index'
import moduleFeedback from './feedback/index'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  isLoading: false,
  message: {},
  showMessage: false,
  stepCounter: 0,
}

// getters are functions
const getters = {
  isLoading: state => state.isLoading,
  stepCounter: state => state.stepCounter,
  showMessage: state => state.showMessage,
  message: state => state.message,
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins,
  modules: {
    users: moduleUser,
    search: moduleSearch,
    pages: modulePage,
    dashboard: moduleDashboard,
    priceHistory: modulePriceHistory,
    feedback: moduleFeedback,
  }
})
